<template>
<!-- OLD LEGACY WEBSITE -->
    <form
        method=""
        action=""
        class="form-group"
        autocomplete="on"
        @submit.prevent="onSubmit"
        @keydown="form.errors.clear($event.target.name)"
    >
        <div id="loader" v-if="isLoading">
            <div class="spinner"></div>
        </div>

        <section v-if="step === 1" class="section">
            <div class="form-group">
                <input type="hidden" name="_token" v-model="form.csrf" />
                <h1>Create your King's Trust account</h1>

                <p>
                    Sign up to start your journey with The King's Trust. Remember, after you've signed up you'll need to log into your account and confirm your interest in attending the course.
                </p>

                <p>
                    All fields with an asterisk are required
                    <i class="fas fa-asterisk"></i>
                </p>

                <StepsBlock :active-step="1"></StepsBlock>

                <div class="form-group">
                    <label for="pronouns" class="form-label">Pronouns</label>

                    <select
                        v-model="form.pronouns"
                        class="form-control form-select col-lg-6"
                        id="pronouns"
                        name="pronouns"
                    >
                        <option value=""></option>
                        <option value="He/Him/His/Himself">
                            He/Him/His/Himself
                        </option>
                        <option value="She/Her/Hers/Herself">
                            She/Her/Hers/Herself
                        </option>
                        <option value="They/Them/Theirs/Themself">
                            They/Them/Theirs/Themself
                        </option>
                        <option value="Ze/Zir/Zirs/Zirself">
                            Ze/Zir/Zirs/Zirself
                        </option>
                    </select>
                    <span
                        class="enquiry-errors"
                        v-if="form.errors.has('pronouns')"
                        v-text="form.errors.get('pronouns')"
                        role="alert"
                        aria-live="assertive"
                    ></span>
                </div>
                <div>
                    <div class="form-row">
                        <div class="form-group col-lg-6">
                            <div>
                                <label class="form-label" for="first_name">First name <i class="fas fa-asterisk"></i></label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="first_name"
                                    name="first_name"
                                    autocomplete="given-name"
                                    v-model="form.first_name"
                                    @input="form.first_name = capitalizeWord($event.target.value)"
                                    required
                                />
                                <span
                                    class="enquiry-errors"
                                    v-if="form.errors.has('first_name')"
                                    v-text="form.errors.get('first_name')"
                                    role="alert"
                                    aria-live="assertive"
                                ></span>
                            </div>
                        </div>

                        <div class="form-group col-lg-6">
                            <div>
                                <label class="form-label" for="last_name">Last name <i class="fas fa-asterisk"></i></label>
                                <input
                                    v-model="form.last_name"
                                    type="text"
                                    class="form-control"
                                    id="last_name"
                                    name="last_name"
                                    autocomplete="family-name"
                                    @input="form.last_name = capitalizeWord($event.target.value)"
                                    required
                                />
                                <span
                                    class="enquiry-errors"
                                    v-if="form.errors.has('last_name')"
                                    v-text="form.errors.get('last_name')"
                                    role="alert"
                                    aria-live="assertive"
                                ></span>
                            </div>
                        </div>
                    </div>
                    <p class="py-4">
                        The Prince’s Trust helps young people between the ages
                        of 16 and 30. If you are outside of this age group we
                        will not be able to register you for an account.
                    </p>

                    <div class="form-row">
                        <div class="form-group col-lg-6">
                            <label class="form-label" for="date_of_birth"
                                >Date of birth (DD/MM/YYYY) <i class="fas fa-asterisk"></i></label
                            >
                            <cleave
                                placeholder="__/__/____"
                                :options="{
                                    date: true,
                                    datePattern: ['d', 'm', 'Y'],
                                    delimiter: '/'
                                }"
                                type="tel"
                                name="date_of_birth"
                                class="form-control date-text"
                                id="date_of_birth"
                                v-model="form.date_of_birth"
                                required
                            >
                            </cleave>

                            <span
                                class="enquiry-errors"
                                v-if="form.errors.has('date_of_birth')"
                                v-text="form.errors.get('date_of_birth')"
                                role="alert"
                                aria-live="assertive"
                            ></span>
                        </div>
                    </div>
                    <div class="form-group py-3">
                        <button class="btn btn-primary" data-cy="btn-next">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section v-if="step === 2" class="section">
            <div class="form-group">
                <input type="hidden" name="_token" v-model="form.csrf" />
                <h1>Create your King's Trust account</h1>

                <p>
                    Please complete the section below to help us improve your
                    learning and support experience, and contact you with
                    relevant information.
                </p>

                <p>
                    All fields with an asterisk are required
                    <i class="fas fa-asterisk"></i>
                </p>

                <StepsBlock :active-step="2"></StepsBlock>

                <div>
                    <div class="form-row">
                        <div class="form-group col-lg-6">
                            <div>
                                <label class="form-label" for="email_address">Email address <i class="fas fa-asterisk"></i></label>
                                <input
                                    type="text"
                                    id="email_address"
                                    class="form-control"
                                    name="email_address"
                                    autocomplete="email"
                                    v-model="form.email_address"
                                    required
                                />

                                <span
                                    class="enquiry-errors"
                                    v-if="form.errors.has('email_address')"
                                    v-html="form.errors.get('email_address')"
                                    role="alert"
                                    aria-live="assertive"
                                ></span>
                            </div>
                        </div>

                        <div class="form-group col-lg-6">
                            <div>
                                <label class="form-label" for="phone_number">Mobile number <i class="fas fa-asterisk"></i></label>
                                <input
                                    type="tel"
                                    id="phone_number"
                                    class="form-control"
                                    name="phone_number"
                                    autocomplete="tel"
                                    v-model="form.phone_number"
                                    required
                                />
                                <span
                                    class="enquiry-errors"
                                    v-if="form.errors.has('phone_number')"
                                    v-text="form.errors.get('phone_number')"
                                    role="alert"
                                    aria-live="assertive"
                                ></span>
                            </div>
                        </div>
                    </div>

                    <p class="py-3">
                        Please enter your Post Code, click ‘Search for address’
                        and select your address from the list.
                    </p>

                    <div class="form-row">
                        <div class="form-group col-lg-6">
                            <label class="form-label" for="postcodeLookup">Post Code <i class="fas fa-asterisk"></i></label>
                            <post-code-look-up
                                v-on:addressChanged="updateAddress"
                            ></post-code-look-up>
                            <span
                                class="enquiry-errors"
                                v-if="form.errors.has('postalCode') && !showNoAddressError"
                                v-text="form.errors.get('postalCode')"
                                role="alert"
                                aria-live="assertive"
                            >
                            </span>

                            <span
                                class="enquiry-errors"
                                v-if="showNoAddressError"
                                role="alert"
                                aria-live="assertive"
                            >
                            An address is required.
                            </span>


                            <fieldset v-if="form.postalCode">
                                <div class="py-3">
                                    <label class="form-label" for="house">House/Flat Number</label>
                                    <input
                                        id="house"
                                        name="addressLine1"
                                        v-model="form.addressLine1"
                                        class="form-control"
                                    />
                                    <span
                                        class="enquiry-errors"
                                        v-if="form.errors.has('addressLine1')"
                                        v-text="form.errors.get('addressLine1')"
                                        role="alert"
                                        aria-live="assertive"
                                    >
                                    </span>
                                </div>
                                <div class="py-3">
                                    <label class="form-label" for="building">Address Line 2</label>
                                    <input
                                        id="building"
                                        name="addressLine2"
                                        v-model="form.addressLine2"
                                        class="form-control"
                                    />
                                    <span
                                        class="enquiry-errors"
                                        v-if="form.errors.has('addressLine2')"
                                        v-text="form.errors.get('addressLine2')"
                                        role="alert"
                                        aria-live="assertive"
                                    >
                                    </span>
                                </div>
                                <div class="py-3">
                                    <label class="form-label" for="street">Address Line 3</label>
                                    <input
                                        id="street"
                                        name="addressLine3"
                                        v-model="form.addressLine3"
                                        class="form-control"
                                    />
                                    <span
                                        class="enquiry-errors"
                                        v-if="form.errors.has('addressLine3')"
                                        v-text="form.errors.get('addressLine3')"
                                        role="alert"
                                        aria-live="assertive"
                                    >
                                    </span>
                                </div>
                                <div class="py-3">
                                    <label class="form-label" for="suburb">Town</label>
                                    <input
                                        id="suburb"
                                        name="locality"
                                        v-model="form.locality"
                                        class="form-control"
                                    />
                                    <span
                                        class="enquiry-errors"
                                        v-if="form.errors.has('locality')"
                                        v-text="form.errors.get('locality')"
                                        role="alert"
                                        aria-live="assertive"
                                    >
                                    </span>
                                </div>
                                <input
                                    type="hidden"
                                    id="district"
                                    name="district"
                                    v-model="form.district"
                                    class="form-control"
                                />
                                <input
                                    type="hidden"
                                    id="ward"
                                    name="ward"
                                    v-model="form.ward"
                                    class="form-control"
                                />
                                <div class="py-3">
                                    <label class="form-label" for="postalCode">Post code</label>
                                    <input
                                        id="postalCode"
                                        name="postalCode"
                                        v-model="form.postalCode"
                                        class="form-control"
                                    />
                                    <span
                                        class="enquiry-errors"
                                        v-if="form.errors.has('postalCode')"
                                        v-text="form.errors.get('postalCode')"
                                        role="alert"
                                        aria-live="assertive"
                                    >
                                    </span>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div class="form-group py-3">
                        <button
                            type="button"
                            class="btn btn-grey-outline me-2"
                            data-cy="btn-back"
                            @click="goBack"
                        >
                            Back
                        </button>
                        <button class="btn btn-primary" data-cy="btn-next">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section v-if="step === 3" class="section">
            <div class="form-group">
                <input type="hidden" name="_token" v-model="form.csrf" />
                <h1>Create your King's Trust account</h1>

                <p>
                    Almost there. We just need a bit more information to get your account set up. Please read the respective documents
                    before ticking the checkbox.
                </p>

                <p>
                    All fields with an asterisk are required
                    <i class="fas fa-asterisk"></i>
                </p>

                <StepsBlock :active-step="3"></StepsBlock>
            </div>

            <div class="form-group">
                <div class="form-check">
                    <input
                        type="checkbox"
                        id="terms_conditions"
                        class="form-check-input"
                        name="terms_and_conditions"
                        v-model="form.terms_and_conditions"
                        required
                    />
                    <label class="form-label form-check-label" for="terms_conditions">
                        I agree to the &nbsp;<a
                            href="https://www.kingstrust.org.uk/privacy-notice/website-terms-and-conditions"
                            target="_blank"
                            >Prince’s Trust website terms and conditions <i class="fas fa-asterisk"></i></a
                        >
                    </label>
                    <br />
                    <span
                        class="enquiry-errors"
                        v-if="form.errors.has('terms_and_conditions')"
                        v-text="form.errors.get('terms_and_conditions')"
                        role="alert"
                        aria-live="assertive"
                    ></span>
                </div>
            </div>

            <div class="form-group">
                <div class="form-check">
                    <input
                        type="checkbox"
                        id="privacy_policy_consent"
                        class="form-check-input"
                        name="privacy_policy_consent"
                        v-model="form.privacy_policy_consent"
                        required
                    />
                    <label
                        class="form-label form-check-label"
                        for="privacy_policy_consent"
                    >
                        I agree to the &nbsp;<a
                            href="https://www.kingstrust.org.uk/privacy-notice"
                            target="_blank"
                            >Prince’s Trust privacy policy <i class="fas fa-asterisk"></i></a
                        >
                    </label>
                    <br />
                    <span
                        class="enquiry-errors"
                        v-if="form.errors.has('privacy_policy_consent')"
                        v-text="form.errors.get('privacy_policy_consent')"
                        role="alert"
                        aria-live="assertive"
                    ></span>
                </div>
            </div>

            <div class="form-group mt-5">
                <fieldset>
                    <legend>
                        <p>Opt-in to new courses and recommendations</p>
                    </legend>

                    <div class="form-check">
                        <input
                            type="checkbox"
                            id="contact_by_phone"
                            class="form-check-input"
                            name="contact_by_phone"
                            v-model="form.contact_by_phone"
                        />
                        <label class="form-label" for="contact_by_phone"> By phone </label>

                        <br />
                        <input
                            type="checkbox"
                            id="contact_by_text"
                            class="form-check-input"
                            name="contact_by_text"
                            v-model="form.contact_by_text"
                        />
                        <label class="form-label" for="contact_by_text"> By text </label>
                        <br />
                        <input
                            type="checkbox"
                            id="contact_by_email"
                            class="form-check-input"
                            name="contact_by_email"
                            v-model="form.contact_by_email"
                        />
                        <label class="form-label" for="contact_by_email"> By email </label>
                        <br />
                        <input
                            type="checkbox"
                            id="contact_by_post"
                            class="form-check-input"
                            name="contact_by_post"
                            v-model="form.contact_by_post"
                        />
                        <label class="form-label form-check-label" for="contact_by_post">
                            By post
                        </label>
                    </div>
                </fieldset>
            </div>

            <div class="form-group">
                <div class="form-check mt-5">
                    <input
                        type="checkbox"
                        id="share_with_funders_consent"
                        class="form-check-input"
                        name="share_with_funders_consent"
                        v-model="form.share_with_funders_consent"
                        required
                    />
                    <label
                        class="form-check-label"
                        for="share_with_funders_consent"
                    >
                        I am happy for The Prince’s Trust to share my
                        information with programme funders <i class="fas fa-asterisk"></i>
                    </label>
                    <br />
                    <span
                        class="enquiry-errors"
                        v-if="form.errors.has('share_with_funders_consent')"
                        v-text="form.errors.get('share_with_funders_consent')"
                        role="alert"
                        aria-live="assertive"
                    ></span>
                </div>
            </div>
            <div class="form-group">
                <label class="mt-4">
                    The password must contain at least 8 characters, a lower
                    case letter, upper case letter, number and one special
                    character.
                </label>
            </div>

            <div class="form-group">
                <div class="col-lg-6 px-0 mt-4">
                    <label for="password"> Create password <i class="fas fa-asterisk"></i></label>
                    <input
                        id="password"
                        type="password"
                        name="password"
                        v-model="form.password"
                        class="form-control"
                        required
                    />
                    <span
                        class="enquiry-errors"
                        v-if="form.errors.has('password')"
                        v-text="form.errors.get('password')"
                        role="alert"
                        aria-live="assertive"
                    ></span>
                </div>
            </div>
            <div class="form-group">
                <div class="col-lg-6 px-0 mt-4">
                    <label for="password_confirmation">
                        Confirm password <i class="fas fa-asterisk"></i>
                    </label>
                    <input
                        id="password_confirmation"
                        type="password"
                        name="password_confirmation"
                        v-model="form.password_confirmation"
                        class="form-control"
                        required
                    />
                </div>

                <span
                    class="enquiry-errors"
                    v-if="form.errors.has('password_confirmation')"
                    v-text="form.errors.get('password_confirmation')"
                    role="alert"
                    aria-live="assertive"
                ></span>
            </div>

            <div class="form-group form-block-gap py-3">
                <button
                    type="button"
                    class="btn btn-grey-outline me-2"
                    data-cy="btn-back"
                    @click="goBack"
                >
                    Back
                </button>
                <button class="btn btn-primary" data-cy="btn-next">
                    Next
                </button>
            </div>
        </section>

        <section v-if="step === 4" class="section">
            <div class="form-group">
                <input type="hidden" name="_token" v-model="form.csrf" />
                <h1>{{ copyTextObject.title }}</h1>

                <div class="alert alert-blue">
                    <div class="alert-heading">
                        Please read our Start Safe guidelines.
                    </div>

                    You’ll need to tick the box at the bottom of the page to let
                    us know that you’ve understood and agree to meet the
                    expectations we’ve set for you.
                </div>

                <StepsBlock :active-step="4"></StepsBlock>

                <p v-html="decoder(copyTextObject.headerText)"></p>

                <p v-html="decoder(copyTextObject.bodyText)"></p>
            </div>

            <div class="alert alert-blue">
                <div class="form-group">
                    <div class="form-check">
                        <input
                            type="checkbox"
                            id="code_of_conduct_consent"
                            class="form-check-input"
                            name="code_of_conduct_consent"
                            v-model="form.code_of_conduct_consent"
                            required
                        />
                        <label
                            class="form-check-label pe-4"
                            for="code_of_conduct_consent"
                        >
                            I have read and understood the Start Safe guidelines
                            and agree to meet the expectations set out by the
                            Prince’s Trust. <i class="fas fa-asterisk"></i>
                        </label>
                        <span
                            class="enquiry-errors"
                            v-if="form.errors.has('code_of_conduct_consent')"
                            v-html="form.errors.get('code_of_conduct_consent')"
                            role="alert"
                            aria-live="assertive"
                        ></span>
                    </div>
                </div>

                <div class="col-md-12 col-lg-10 col-xl-8">
                    <div class="form-group">
                        <span
                            class="enquiry-errors"
                            v-if="form.errors.has('signup')"
                            v-html="form.errors.get('signup')"
                            role="alert"
                            aria-live="assertive"
                        ></span>
                    </div>
                    <button
                        class="btn btn-primary btn-block"
                        data-cy="btn-next"
                    >
                        Complete sign-up
                    </button>
                    <button
                        type="button"
                        class="btn btn-grey-outline me-2 btn-block"
                        data-cy="btn-back"
                        @click="goBack"
                    >
                        Back
                    </button>
                </div>
            </div>
        </section>

        <section v-if="step === 5" class="section" data-cy="step-5">
            <div class="form-group">
                <h1>Activate your account</h1>

                <h2>Thanks for signing up! Check your inbox…</h2>

                <p>
                    We just need to confirm that the email address you submitted
                    is yours.
                </p>
                <p>
                    Check your account activation email. To confirm your email
                    address, you’ll need to click the link in the email. This
                    will activate your account and give you access to the
                    learning and support you need to start your journey.
                </p>

                <h3>How do I confirm my interest in the course?</h3>

                <p>Remember, once we’ve activated your account you will need to visit the Confirm Your Interest page to find out more information and confirm your interest in attending the course.</p>

                <p>You’ll need to watch the information video on this page in full before you can confirm your interest. We’ll then ask you to share some details with us so we can make sure receive the support you need. This involves completing a short form.</p>
            </div>
            <div class="form-group py-4">
                <a href="/" class="btn btn-primary px-5 btn-link" data-cy="btn-next">
                    Return to homepage
                </a>
            </div>
        </section>
    </form>
</template>

<script>
import Form from "../Form.js";
import Cleave from "vue-cleave";
import PostCodeLookUp from "./PostCodeLookUp";
import StepsBlock from "./StepsBlock";

export default {
    components: {
        Cleave,
        PostCodeLookUp,
        StepsBlock
    },
    props: {
        previousSession: Object,
    },
    updated() {
        if(this.step === 5) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({'event': 'form_complete'});
        }
    },
    data: function () {
        return {
            isLoading: false,
            errors: [],
            step: 1,
            copyTextObject: JSON.parse(
                window.completeSignupCopy.replace(/&quot;/g, '"')
            ),
            form: new Form({
                pronouns: "",
                first_name: "",
                last_name: "",
                addressLine1: "",
                addressLine2: "",
                addressLine3: "",
                locality: "",
                district: "",
                ward: "",
                postalCode: "",
                phone_number: "",
                email_address: "",
                date_of_birth: "",
                terms_and_conditions: "",
                privacy_policy_consent: "",
                share_with_funders_consent: "",
                password: "",
                password_confirmation: "",
                recommendations: "",
                code_of_conduct_consent: "",
                contact_by_phone: "",
                contact_by_text: "",
                contact_by_email: "",
                contact_by_post: "",
                _method: "POST",
            }),
            address: {
                populated: false,
                submitted: false
            }
        };
    },
    created() {
        this.previousSession && this.form.merge(this.previousSession);
    },
    computed: {
      showNoAddressError() {
          return !this.address.populated && this.address.submitted;
      }
    },
    methods: {
        onSubmit() {
            let age = this.getAge(this.form.date_of_birth);
            if (age === 'incomplete') {
                alert("This date of birth is incomplete. Have you entered it correctly? (DD/MM/YYYY)");
                return;
            }
            if (age === false) {
                alert(
                    "This date of birth is outside of our 16 to 30 age group. Have you entered it correctly? (DD/MM/YYYY)"
                );
                return;
            }
            this.isLoading = true;

            // If we're progressing from step 2, mark as having been submitted so we can determine whether to show an error for the address.
            if(this.step === 2) {
                this.address.submitted = true;
            }
            if(this.step === 5) {
                window.dataLayer.push({ 'formSubmission': 'form_complete' });
            }
            this.form
                .post("/enquiry/step" + this.step)
                .then((response) => this.goForward())
                .finally(() => (this.isLoading = false));
        },
        goBack() {
            this.step--;
            this.scrollToTop();
        },
        goForward() {
            this.step++;
            this.scrollToTop();
        },
        decoder(str) {
            const textArea = document.createElement("textarea");
            textArea.innerHTML = str;

            return textArea.value;
        },
        capitalizeWord(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        getAge(DOB) {
            if(!DOB){
                return null;
            }
            let today = new Date();
            let dateParts = DOB.split("/");
            // month is 0-based, that's why we need dataParts[1] - 1
            let dateObject = new Date(
                +dateParts[2],
                dateParts[1] - 1,
                +dateParts[0]
            );

            let age = today.getFullYear() - dateObject.getFullYear();
            let m = today.getMonth() - dateObject.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dateObject.getDate())) {
                age = age - 1;
            }

            if (dateParts[0] === "" ||
                dateParts[0].length !== 2 ||
                dateParts[1] === "" ||
                dateParts[1].length !== 2 ||
                dateParts[2] === "" ||
                dateParts[2].length !== 4) {
                return "incomplete";
            }

            if (age < 16 || age > 31) {
                return false;
            }
        },
        updateAddress(payLoad) {
            this.scrollToAddress();
            this.address.populated = true;

            let addressArray = payLoad;
            this.form.addressLine1 = addressArray[0]["addressLine1"];
            this.form.addressLine2 = addressArray[1]["addressLine2"];
            this.form.addressLine3 = addressArray[2]["addressLine3"];
            this.form.locality = addressArray[3]["locality"];
            this.form.postalCode = addressArray[5]["postalCode"];
            this.form.district = addressArray[7]["district"];
            this.form.ward = addressArray[8]["ward"];
        },
        scrollToTop() {
            window.scrollTo(0, 0)
        },
        scrollToAddress() {
            const address = document.getElementsByClassName('postcode-lookup-addresses')[0];

            if(address) {
                // Find the parent element (question) of the address class.
                const parent = address.parentNode;
                const { bottom } = parent.getBoundingClientRect();

                // Scroll to just above the parent element so we've got clear context.
                const offsetY = Math.max(0, window.pageYOffset + bottom - 30);
                window.scrollTo({ top: offsetY, behavior: 'smooth' });
            }
        }
    },
};
</script>
